export const DASHBOARD_KPI_REQ = 'DASHBOARD_KPI_REQ'
export const DASHBOARD_KPI_SUCCESS = 'DASHBOARD_KPI_SUCCESS'
export const DASHBOARD_KPI_ERROR = 'DASHBOARD_KPI_ERROR'
export const DASHBOARD_KPI_SET = 'DASHBOARD_KPI_SET'
export const DASHBOARD_KPI_RESET_STATUS = 'DASHBOARD_KPI_RESET_STATUS'

export const DASHBOARD_INSIGHTS_REQ = 'DASHBOARD_INSIGHTS_REQ'
export const DASHBOARD_INSIGHTS_SUCCESS = 'DASHBOARD_INSIGHTS_SUCCESS'
export const DASHBOARD_INSIGHTS_ERROR = 'DASHBOARD_INSIGHTS_ERROR'
export const DASHBOARD_INSIGHTS_SET = 'DASHBOARD_INSIGHTS_SET'
export const DASHBOARD_INSIGHTS_RESET_STATUS = 'DASHBOARD_INSIGHTS_RESET_STATUS'

export const ACTIVITY_EVENT_REQ = 'ACTIVITY_EVENT_REQ'
export const ACTIVITY_EVENT_SUCCESS = 'ACTIVITY_EVENT_SUCCESS'
export const ACTIVITY_EVENT_ERROR = 'ACTIVITY_EVENT_ERROR'
export const ACTIVITY_EVENT_SET = 'ACTIVITY_EVENT_SET'
export const ACTIVITY_EVENT_RESET_STATUS = 'ACTIVITY_EVENT_RESET_STATUS'



// WEBPACK FOOTER //
// ./src/store/modules/dashboard/kpi-statistics.type.js